<template>
  <BasePanelWithHeader headerText="Special District">
    <template v-slot:content>
      <v-row>
        <v-col cols="12" sm="auto">
          <v-switch v-model="showInactive" label="Show Inactive"></v-switch>
        </v-col>
        <v-col class="ml-auto" cols="12" sm="auto">
          <v-text-field
            v-model="searchText"
            prepend-inner-icon="mdi-magnify"
            label="Search"
            clearable
          >
          </v-text-field>
        </v-col>
        <v-col cols="12" sm="auto" class="mt-4 mr-4">
          <BaseTooltipButton
            small
            @click="$refs.luSpecialDistrictForm.addLuSpecialDistrict()"
            icon="mdi-plus"
            iconColor="white"
            buttonClass="primary"
            >Add Special District
          </BaseTooltipButton>
        </v-col>
      </v-row>
      <v-data-table
        :headers="filteredHeaders"
        :items="filteredLuSpecialDistrict"
        :search="searchText"
        class="pt-4"
        :loading="loading"
        dense
      >
        <template v-slot:item.edit="{item}">
          <BaseTooltipButton
            small
            @click="$refs.luSpecialDistrictForm.editLuSpecialDistrict(item)"
            iconColor="primary"
            icon="mdi-pencil"
            >Edit Special District
          </BaseTooltipButton>
        </template>
        <template v-slot:item.delete="{item}">
          <BaseTooltipButton
            small
            @click="$refs.luSpecialDistrictDelete.deleteConfirm(item)"
            iconColor="primary"
            icon="mdi-delete"
            >Delete Special District
          </BaseTooltipButton>
        </template>
        <template v-slot:item.IsActive="{item}">
          {{ item.IsActive ? 'Yes' : 'No' }}
        </template>
      </v-data-table>
      <BaseDeleteConfirm
        ref="luSpecialDistrictDelete"
        :delete="deleteLuSpecialDistrict"
        @refresh="clearLookupCacheAndReloadLuSpecialDistrict"
      >
        Are you sure you want to delete this special district?
      </BaseDeleteConfirm>
      <LuSpecialDistrictDialogForm
        ref="luSpecialDistrictForm"
        @refresh="clearLookupCacheAndReloadLuSpecialDistrict"
      >
      </LuSpecialDistrictDialogForm>
    </template>
  </BasePanelWithHeader>
</template>
<script>
import {get, sync, commit, call} from 'vuex-pathify'
import LuSpecialDistrictDialogForm from '@components/form/add-edit/LuSpecialDistrictDialog'
export default {
  components: {
    LuSpecialDistrictDialogForm,
  },
  data: () => ({
    searchText: '',
    showInactive: false,
  }),
  created() {
    this.loadLuSpecialDistrict()
  },
  computed: {
    ...get('luSpecialDistrict', ['luSpecialDistrict', 'loading']),
    filteredLuSpecialDistrict() {
      var list = this.luSpecialDistrict.filter((i) => true)
      if (!this.showInactive) {
        list = list.filter((i) => i.IsActive)
      }
      return list
    },
    headers() {
      return [
        {
          text: '',
          align: 'center',
          value: 'edit',
          visible: true,
          sortable: false,
        },
        {
          text: 'ID',
          align: 'center',
          sortable: true,
          value: 'ID',
          visible: false,
        },
        {
          text: 'Special District',
          align: 'center',
          sortable: true,
          value: 'SpecialDistrict',
          visible: true,
        },
        {
          text: 'DOR Jurisdiction',
          align: 'center',
          sortable: true,
          value: 'DORJurisdiction',
          visible: true,
        },
        {
          text: 'County',
          align: 'center',
          sortable: true,
          value: 'County.Name',
          visible: true,
        },
        {
          text: 'Is Active',
          align: 'center',
          sortable: true,
          value: 'IsActive',
          visible: this.showInactive,
        },
        {
          text: '',
          align: 'center',
          value: 'delete',
          visible: false,
          sortable: false,
        },
      ]
    },
    filteredHeaders() {
      return this.headers.filter((h) => h.visible)
    },
  },
  methods: {
    ...call('luSpecialDistrict', [
      'deleteLuSpecialDistrict',
      'loadLuSpecialDistrict',
      'clearLookupCacheAndReloadLuSpecialDistrict',
    ]),
  },
}
</script>
<style></style>
